export const PinIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none">
      <path
        d="M6.5 8.75C7.74264 8.75 8.75 7.74264 8.75 6.5C8.75 5.25736 7.74264 4.25 6.5 4.25C5.25736 4.25 4.25 5.25736 4.25 6.5C4.25 7.74264 5.25736 8.75 6.5 8.75Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 15.5C9.5 12.5 12.5 9.81371 12.5 6.5C12.5 3.18629 9.81371 0.5 6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5C0.5 9.81371 3.5 12.5 6.5 15.5Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
